const routes = [
    {
        path: "/library-rooms",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "libraryroom_index"
        }
    }
];

export default routes;
